import React, { useEffect, useRef } from 'react';
import './Title.css';

export default function Heading() {
    const titleRef = useRef(null);
    const descriptionRef = useRef(null);

    useEffect(() => {
        // Simple entrance animation
        const title = titleRef.current;
        const description = descriptionRef.current;

        if (title && description) {
            setTimeout(() => {
                title.classList.add('visible');
            }, 300);

            setTimeout(() => {
                description.classList.add('visible');
            }, 700);
        }
    }, []);

    return (
        <div className='welcomeparent'>
            <div className="title-container" ref={titleRef}>
                <h1 className='welcome'><b>Welcome to</b></h1>
                <h1 className='welcome'><b>Waghchaure Lawns</b></h1>
            </div>
            <div className="description-container" ref={descriptionRef}>
                <p className='description text-light'>
                    Waghchaure Lawns is a prominent event venue. The venue offers a spacious lawn,
                    making it an ideal choice for hosting various events such as weddings, receptions,
                    and other social gatherings.
                </p>
            </div>
        </div>
    );
}
